import classNames from 'classnames'
import type { VFC } from 'react'

import { type AttributePickers } from 'views/containers/browser/ProductVariantsAttributesContainer/AttributePicker'

const AttributePickerMultipleAttribute: VFC<AttributePickers> = ({
  pickerValue,
  id,
  styles,
}) => {
  const multipleAttributePickerClasses = classNames(
    styles,
    'u-margin-x-small--top u-margin-small--right a-full-width u-text-truncate u-display--inline-block u-text-align--left'
  )

  return (
    <button
      className={multipleAttributePickerClasses}
      id={id}
      name="variantAttribute"
      title={pickerValue}
      value={pickerValue}
      data-qa-id={`attributePicker-${id}`}
    >
      {pickerValue}
    </button>
  )
}

export default AttributePickerMultipleAttribute
